/* BUNDU · cro-octubre-2026
   Mensaje de pack dentro del carrito lateral (Qikify).
   El descuento lo aplica Shopify solo: 15% con 2 frascos de BUNDU Hair y 20% con 3.
   Este script le cuenta al cliente cuánto ahorra si agrega uno más y suma al carrito
   envío gratis, el ahorro total, tres razones de confianza y los medios de pago bajo el botón. */
(function () {
  var style = document.createElement('style');
  style.textContent = "/* Carrito lateral · aviso de pack para BUNDU Hair (lo pinta assets/bundu-cro.js). */\n.qsc2-drawer .bundu-pack-nudge {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0 16px;\n  padding: 14px 0;\n  border-bottom: 1px solid rgba(43, 39, 36, 0.1);\n}\n.qsc2-drawer .bundu-pack-nudge__img {\n  flex: 0 0 52px;\n  width: 52px;\n  height: 52px;\n  border-radius: 8px;\n  background: #f4f2ed;\n  object-fit: contain;\n}\n.qsc2-drawer .bundu-pack-nudge__copy { flex: 1 1 auto; min-width: 0; }\n.qsc2-drawer .bundu-pack-nudge__title {\n  margin: 0 0 2px;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #2b2724;\n}\n.qsc2-drawer .bundu-pack-nudge__text {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.4;\n  color: #6b6158;\n}\n.qsc2-drawer .bundu-pack-nudge__text s { margin-right: 4px; opacity: 0.8; }\n.qsc2-drawer .bundu-pack-nudge__btn {\n  flex: 0 0 auto;\n  height: 34px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 999px;\n  background: #5c7346;\n  color: #ffffff;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n.qsc2-drawer .bundu-pack-nudge__btn:hover { background: #4a5e37; }\n.qsc2-drawer .bundu-pack-nudge__btn[disabled] { opacity: 0.6; cursor: wait; }\n.qsc2-drawer .bundu-pack-nudge--done .bundu-pack-nudge__title { font-weight: 500; color: #4a5e37; }\n.qsc2-drawer .bundu-cart-ship {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin: 0;\n  padding: 10px 16px;\n  background: #5c7346;\n  color: #ffffff;\n  font-size: 13px;\n  line-height: 1.3;\n  text-align: center;\n}\n.qsc2-drawer .bundu-cart-ship svg { flex: 0 0 18px; width: 18px; height: 18px; }\n.qsc2-drawer .bundu-cart-ship strong { font-weight: 600; }\n.qsc2-drawer .bundu-cart-save {\n  display: inline-block;\n  margin-left: 8px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #e8eedd;\n  color: #4a5e37;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  vertical-align: middle;\n}\n.qsc2-drawer .qsc2-checkout-button { border-radius: 999px !important; }\n.qsc2-drawer .bundu-cart-trust {\n  margin: 12px 0 0;\n  text-align: center;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #6b6158;\n}\n.qsc2-drawer .bundu-cart-trust p { display: flex; flex-wrap: wrap; align-items: center; justify-content: center; gap: 4px 18px; margin: 0 0 4px; }\n.qsc2-drawer .bundu-cart-trust p:last-child { margin-bottom: 0; }\n.qsc2-drawer .bundu-cart-trust__item { display: inline-flex; align-items: center; gap: 6px; }\n.qsc2-drawer .bundu-cart-trust__item svg { flex: 0 0 15px; width: 15px; height: 15px; color: #5c7346; }\n.qsc2-drawer .bundu-cart-trust__stars { letter-spacing: 1px; color: #5c7346; }\nbody.bundu-cart-open .whatsapp-floating-button { display: none !important; }\n";
  document.head.appendChild(style);

  var HAIR_VARIANT = 44822601662690;
  var TIERS = { 2: 0.15, 3: 0.2 };
  var busy = false;
  var lastQty = null;
  var timer = null;

  function money(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CO');
  }


  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/></svg>',
    cash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="6.5" width="18" height="11" rx="2"/><circle cx="12" cy="12" r="2.4"/><path d="M6.5 9.5v5M17.5 9.5v5"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4.5" y="10" width="15" height="10.5" rx="2.5"/><path d="M8 10V7.5a4 4 0 0 1 8 0V10"/><path d="M12 14.2v2.3"/></svg>',
    card: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.75" y="5.5" width="18.5" height="13" rx="2.5"/><path d="M2.75 9.75h18.5"/><path d="M6.5 15h3"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14 4.5 9.5 9 5"/><path d="M4.5 9.5H15a4.5 4.5 0 0 1 0 9h-3"/></svg>'
  };
  var DATA = window.BUNDU_CRO || {};

  function extras(cart) {
    var drawer = document.querySelector('.qsc2-drawer');
    if (!drawer) return;
    document.body.classList.toggle('bundu-cart-open', !drawer.classList.contains('qsc2-drawer--hidden'));
    var body = drawer.querySelector('.qsc2-drawer-body');
    var hasItems = cart.item_count > 0;

    var ship = drawer.querySelector('.bundu-cart-ship');
    if (hasItems && body && !ship) {
      ship = document.createElement('div');
      ship.className = 'bundu-cart-ship';
      ship.innerHTML = ICONS.truck + '<span><strong>Envío gratis</strong> a toda Colombia. Llega en 2 a 4 días hábiles a ciudades principales.</span>';
      body.insertBefore(ship, body.firstChild);
    } else if (!hasItems && ship) {
      ship.remove();
    }

    var subtotalLabel = drawer.querySelector('.qsc2-drawer-footer__summary-subtotal > div');
    var pill = drawer.querySelector('.bundu-cart-save');
    if (subtotalLabel) {
      if (cart.total_discount > 0) {
        if (!pill) {
          pill = document.createElement('span');
          pill.className = 'bundu-cart-save';
          subtotalLabel.appendChild(pill);
        }
        pill.textContent = 'Ahorras ' + money(cart.total_discount);
      } else if (pill) {
        pill.remove();
      }
    }

    var checkout = drawer.querySelector('.qsc2-drawer-footer__checkout');
    if (checkout && !drawer.querySelector('.bundu-cart-trust')) {
      var rating = parseFloat(DATA.rating);
      var count = parseInt(DATA.reviews, 10);
      var reviewsText = count > 0
        ? (rating ? rating.toFixed(1).replace('.', ',') + ' de 5 en ' : '') + count + ' reseñas'
        : 'Reseñas de clientes reales';
      var list = document.createElement('div');
      list.className = 'bundu-cart-trust';
      list.innerHTML =
        '<p><span class="bundu-cart-trust__item"><span class="bundu-cart-trust__stars" aria-hidden="true">★★★★★</span><span class="bundu-cart-trust__reviews"></span></span></p>' +
        '<p><span class="bundu-cart-trust__item">' + ICONS.lock + 'Pago seguro</span><span class="bundu-cart-trust__item">' + ICONS.back + '5 días hábiles para retracto</span></p>' +
        '<p><span class="bundu-cart-trust__item">' + ICONS.card + 'Tarjeta, PSE, transferencia o contra entrega</span></p>';
      list.querySelector('.bundu-cart-trust__reviews').textContent = reviewsText;
      checkout.parentNode.insertBefore(list, checkout.nextSibling);
    }
  }

  function build(qty, unit, img) {
    var box = document.createElement('div');
    box.className = 'bundu-pack-nudge';
    var title, old, text, cta;
    if (qty === 1) {
      title = 'Suma el segundo frasco por ' + money(unit * 2 * (1 - TIERS[2]) - unit);
      old = money(unit);
      text = '15% menos en los dos';
      cta = 'Agregar';
    } else if (qty === 2) {
      title = 'Suma el tercer frasco por ' + money(unit * 3 * (1 - TIERS[3]) - unit * 2 * (1 - TIERS[2]));
      old = money(unit);
      text = '20% menos en los tres';
      cta = 'Agregar';
    } else {
      title = 'Ya tienes el mejor precio en BUNDU Hair';
      old = null;
      text = '20% menos en cada frasco';
      cta = null;
      box.className += ' bundu-pack-nudge--done';
    }
    box.innerHTML =
      (img ? '<img class="bundu-pack-nudge__img" alt="" width="52" height="52" loading="lazy">' : '') +
      '<div class="bundu-pack-nudge__copy">' +
        '<p class="bundu-pack-nudge__title"></p>' +
        '<p class="bundu-pack-nudge__text">' + (old ? '<s></s>' : '') + '<span></span></p>' +
      '</div>' +
      (cta ? '<button type="button" class="bundu-pack-nudge__btn"></button>' : '');
    if (img) box.querySelector('img').src = img;
    box.querySelector('.bundu-pack-nudge__title').textContent = title;
    if (old) box.querySelector('.bundu-pack-nudge__text s').textContent = old;
    box.querySelector('.bundu-pack-nudge__text span').textContent = text;
    if (cta) {
      var btn = box.querySelector('.bundu-pack-nudge__btn');
      btn.textContent = cta;
      btn.addEventListener('click', function () {
        if (busy) return;
        busy = true;
        btn.disabled = true;
        btn.textContent = 'Agregando…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: HAIR_VARIANT, quantity: 1 }] })
        })
          .catch(function () {})
          .then(function () {
            busy = false;
            lastQty = null;
            schedule();
          });
      });
    }
    return box;
  }

  function render() {
    var body = document.querySelector('.qsc2-drawer .qsc2-drawer-body');
    if (!body) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        extras(cart);
        var qty = 0;
        var unit = 0;
        var img = '';
        (cart.items || []).forEach(function (item) {
          if (item.variant_id === HAIR_VARIANT) {
            qty += item.quantity;
            unit = item.original_price || item.price;
            if (item.image) img = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
          }
        });
        var current = body.querySelector('.bundu-pack-nudge');
        if (!qty) {
          if (current) current.remove();
          lastQty = 0;
          return;
        }
        if (current && lastQty === qty) return;
        if (current) current.remove();
        var anchor = body.querySelector('.bundu-cart-ship');
        body.insertBefore(build(qty, unit, img), anchor ? anchor.nextSibling : body.firstChild);
        lastQty = qty;
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(render, 250);
  }

  function watch() {
    var drawer = document.querySelector('.qsc2-drawer');
    if (!drawer) return false;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.closest && t.closest('.bundu-pack-nudge, .bundu-cart-ship, .bundu-cart-trust, .bundu-cart-save')) continue;
        schedule();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    schedule();
    return true;
  }

  if (!watch()) {
    var tries = 0;
    var wait = setInterval(function () {
      tries++;
      if (watch() || tries > 40) clearInterval(wait);
    }, 500);
  }
})();
